import { cn } from '@baseball-near-you/ui';
import { urlFor } from '@bb/lib/sanity/utils';
import { getImageDimensions } from '@sanity/asset-utils';
import type { CSSProperties } from 'react';
import { ResponsiveNextImage } from '../ResponsiveNextImage';

export function SanityImageComponent(props: {
  value: any;
  fill?: {
    objectFit: 'contain' | 'cover';
    objectPosition?:
      | 'center'
      | 'top'
      | 'bottom'
      | 'left'
      | 'right'
      | 'top left'
      | 'top right'
      | 'bottom left'
      | 'bottom right';
  };
  cover?: boolean;
  style?: CSSProperties;
  priority?: boolean;
  className?: string;
}) {
  try {
    const { width, height } = getImageDimensions(
      urlFor(props.value.asset).url()
    );

    return (
      <ResponsiveNextImage
        containerClassName={cn(
          'overflow-hidden',
          props.fill && 'h-full w-full',
          props.className
        )}
        nextImageProps={{
          alt: 'cropped result',
          ...(!props.fill
            ? {
                height,
                width,
                style: {
                  objectFit: 'contain',
                  aspectRatio: width / height,
                  maxHeight: '100%',
                  ...props.style,
                },
              }
            : {
                style: {
                  objectFit: props.fill.objectFit,
                  objectPosition: props.fill.objectPosition ?? 'center',
                  ...props.style,
                },
                className: 'w-full h-full top-0 left-0 object-cover',
                fill: true,
              }),
          fill: !!props.fill,
          src: urlFor(props.value.asset).fit('max').auto('format').url(),
          priority: props.priority,
          quality: 100,
          unoptimized: true,
        }}
      />
    );
  } catch (e) {
    console.error(e);
    return null;
  }
}
